import { NavigoIconButton } from '@/components/Navigo/elements/NavigoIconButton'
import { ReadOnlyTooltip } from '@/components/smartUtils/plan/ReadOnlyTooltip'
import { Email } from '@/icons'

import { useTexts } from '../useTexts'

interface Props {
  onClick: () => void
  disabled: boolean
}

export function SendMessageButton(props: Props) {
  const { disabled, onClick } = props
  const texts = useTexts()

  return (
    <ReadOnlyTooltip
      canEdit={!disabled}
      title={texts.notAvailableInThePast}
      render={preventEditing => (
        <NavigoIconButton
          onClick={onClick}
          text={texts.sendMessage}
          disabled={preventEditing || disabled}
          testid="navigo-device-overview-actions-sendMessage"
          Icon={<Email size={20} color={preventEditing || disabled ? '$silver' : '$nightRider'} />}
        />
      )}
    />
  )
}
